import { Validators } from '@angular/forms';

export class SecurityDetailsModel {
  securityList = {
    value: [],
    validation: Validators.compose([]),
  };
  faDataCheck = {
    value: null,
    validation: Validators.compose([]),
  };
}

export class IndividualSecurityModel {
  collateralId = {
    value: null,
    validation: Validators.compose([]),
  };
  securityId = {
    value: null,
    validation: Validators.compose([]),
  };
  propertyNotFound = {
    value: false,
    validation: Validators.compose([]),
  };
  mortgageType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ]),
  };
  occupancy = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ]),
  };
  securityType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ]),
  };
  securityStatus = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ]),
  };
  estimatedValue = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.min(1)
    ]),
  };
  mortgators = {
    value: [],
    validation: Validators.compose([])
  };
  propertyBeingPurchased = {
    value: false,
    validation: Validators.compose([])
  };
  contractDate = {
    value: null,
    validation: Validators.compose([]),
  };
  financeDate = {
    value: null,
    validation: Validators.compose([]),
  };
  settlementDate = {
    value: null,
    validation: Validators.compose([]),
  };
  realEstateAgent = {
    value: null,
    validation: Validators.compose([]),
  };
  realEstateName = {
    value: null,
    validation: Validators.compose([]),
  };
  realEstatePhone = {
    value: null,
    validation: Validators.compose([]),
  };
  realEstateEmail = {
    value: null,
    validation: Validators.compose([]),
  };
  valuationType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ]),
  };
  valuerId = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  accessInstructions = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  valuationContactNumber = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  valuationContactName = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  valuerName = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  valuerContactDetails = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  valexId = {
    value: null,
    validation: Validators.compose([
      Validators.minLength(8),
      Validators.maxLength(8),
      Validators.pattern('^[a-zA-Z0-9]*$'),
    ]),
  };
  valuationFee = {
    value: 0,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  inspectionDate = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  valuationFirm = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  valuerQualifications = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ]),
  };
  currentUse = {
    value: null,
    validation: Validators.compose([]),
  };
  mainBuilding = {
    value: null,
    validation: Validators.compose([]),
  };
  zoning = {
    value: null,
    validation: Validators.compose([]),
  };
  interestValued = {
    value: null,
    validation: Validators.compose([]),
  };
  livingArea = {
    value: 0,
    validation: Validators.compose([]),
  };
  livingAreaMeasurement = {
    value: 'square-metres',
    validation: Validators.compose([]),
  };
  unitsInDev = {
    value: 0,
    validation: Validators.compose([]),
  };
  siteArea = {
    value: 0,
    validation: Validators.compose([]),
  };
  siteAreaMeasurement = {
    value: 'square-metres',
    validation: Validators.compose([]),
  };
  valueComponent = {
    value: 0,
    validation: Validators.compose([]),
  };
  rentalValue = {
    value: 0,
    validation: Validators.compose([]),
  };
  insuranceValue = {
    value: 0,
    validation: Validators.compose([]),
  };
  landValue = {
    value: 0,
    validation: Validators.compose([]),
  };
  improvementsValue = {
    value: 0,
    validation: Validators.compose([]),
  };
  marketValue = {
    value: 0,
    validation: Validators.compose([]),
  };
  builder = {
    value: null,
    validation: Validators.compose([]),
  };
  /* builderEmail = {
    value: null,
    validation: Validators.compose([]),
  }; */
  builderContractDate = {
    value: null,
    validation: Validators.compose([]),
  };
  builderTenderPrice = {
    value: 0,
    validation: Validators.compose([]),
  };
  builderCheckCost = {
    value: 0,
    validation: Validators.compose([]),
  };
  asIfComplete = {
    value: 0,
    validation: Validators.compose([]),
  };
  link = {
    value: null,
    validation: Validators.compose([]),
  };
  securityAddress = {
    value: null,
    validation: Validators.compose([]),
  };
  useAsSecurity = {
    value: null,
    validation: Validators.compose([]),
  };
  valuerAccessBorrower = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ]),
  };
  valuerAccessBorrowers = [];
  valuerAccessOther = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ]),
  };
  valuerAccessOtherContactType = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  valuerAccessOtherContactName = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  valuerAccessOtherCompanyName = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  valuerAccessOtherPhoneOneType = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  valuerAccessOtherPhoneOneNumber = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  valuerAccessOtherPhoneTwoType = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  valuerAccessOtherPhoneTwoNumber = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  valuerAccessInstructions = {
    value: null,
    validation: Validators.compose([
      Validators.maxLength(200)
    ]),
    disabled: true
  };
}

export class IndividualMortgatorModel {
  name = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
}

export class BorrowerContactModel {
  selected = {
    value: null,
    validation: Validators.compose([])
  };
  borrowerId = {
    value: null,
    validation: Validators.compose([])
  };
  firstName = {
    value: null,
    validation: Validators.compose([])
  };
  lastName = {
    value: 0,
    validation: Validators.compose([])
  };
  dateOfBirth = {
    value: null,
    validation: Validators.compose([])
  };
}
